import { Stack } from "@mui/material";
import React from "react";

const ThirdSections = () => {
  return (
    <Stack>
      {" "}
      <Stack
        sx={{
          //   height: "40vh",
          display: "flex",
          flexDirection: "column",
          width: "100%",
          //   border: "1px solid red",
          justifyContent: "center",
          alignItems: "center",
          gap: 3,
          marginTop: {
            xl: "40px",
            lg: "40px",
            md: "32px",
            sm: "32px",
            xs: "28px",
          },

          marginBottom: {
            xl: "40px",
            lg: "40px",
            md: "32px",
            sm: "32px",
            xs: "28px",
          },
        }}
      >
        <Stack
          sx={{
            width: { xl: "72%", lg: "89%", md: "89%", sm: "94%", xs: "92%" },
            // border: "1px solid blue",
          }}
        >
          <Stack
            sx={{
              fontFamily: "'Roboto', sans-serif",
              fontSize: {
                xs: "20px",
                sm: "30px",
                md: "28px",
                lg: "48px",
                xl: "48px",
              },
              lineHeight: {
                xs: "24px",
                sm: "36px",
                md: "32px",
                lg: "52px",
                xl: "52px",
              },
              fontWeight: 600,
              color: "rgb(5 78 146)",
              textAlign: "center",
              marginBottom: {
                xs: "20px",
                sm: "20px",
                md: "20px",
                lg: "20px",
                xl: "20px",
              },

              display: "flex",
              flexDirection: "row",
            }}
          >
            <Stack
              sx={{
                // border: "1px solid red",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Stack
                sx={{
                  width: { xl: "6px", lg: "6px", xs: "4px" },
                  // height: { xl: "100%", lg: "100%", xs: "100%" },
                  height: {
                    xs: "20px",
                    sm: "44px",
                    md: "28px",
                    lg: "40px",
                    xl: "40px",
                  },
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  border: "1px solid rgb(5 78 146)",
                  // backgroundColor: "rgb(5 78 146)",
                  backgroundColor: "rgb(5 78 146)",
                  marginRight: {
                    xs: "8px",
                    sm: "8px",
                    md: "12px",
                    lg: "12px",
                    xl: "12px",
                  },
                  borderTopRightRadius: "8px", // Adjust the value as needed
                  borderBottomRightRadius: "8px", // Adjust the value as needed
                }}
              >
                <h4 style={{ color: "rgb(5 78 146)" }}>{""}</h4>
              </Stack>
            </Stack>
            <span style={{ display: "inline-flex", alignItems: "center" }}>
              Main Features
            </span>
          </Stack>

          {/* <Stack
            sx={{
              fontSize: {
                xs: "12px",
                sm: "16px",
                md: "16px",
                lg: "24px",
                xl: "24px",
              },
              lineHeight: {
                xs: "22px",
                sm: "22px",
                md: "28px",
                lg: "28px",
                xl: "32px",
              },
              fontWeight: { xs: 400, sm: 400, md: 300, lg: 300, xl: 100 },
              fontFamily: "'Roboto', sans-serif",
              color: "#333",
            }}
          >
            Vertex Suite is the smartest WhatsApp Engagement Platform. With Vertex Suite you can:
          </Stack> */}
          <Stack
            sx={{
              width: "100%",
              fontFamily: "'Roboto', sans-serif",
              fontSize: {
                xs: "16px",
                sm: "16px",
                md: "16px",
                lg: "24px",
                xl: "24px",
              },
              lineHeight: {
                xs: "24px",
                sm: "28px",
                md: "32px",
                lg: "32px",
                xl: "32px",
              },
              fontWeight: { xs: 400, sm: 400, md: 400, lg: 400, xl: 400 },
              color: "#333",
              border: "1px solid #f1f8ff",
              textAlign: "left",
              // border: "1px solid rgb(218 233 248)",
              padding: { xs: 1, sm: 2 },
              borderRadius: "8px",
              backgroundColor: "#f1f8ff",
              // marginBottom: {
              //   xs: "20px",
              //   sm: "20px",
              //   md: "20px",
              //   lg: "64px",
              //   xl: "64px",
              // },
            }}
          >
            Explore the powerful features that make our WhatsApp solution fast,
            reliableand easy to scale across industries.
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default ThirdSections;
